import $tour from '@api/tour';
class tour {
  constructor () {}
  // 获取数据
  async getBaseData () {
    // const data = JSON.parse(localStorage.getItem('tourData'));
    // if ( data ) { return data; }
    const res = await $tour.baseData();
    localStorage.setItem('tourData', JSON.stringify(res));
    return res;
  }
}
export default new tour();